export const PREFERENCE_KEY_PROPERTY_QUERY = "PROPERTY_QUERY_V2";
export const PREFERENCE_KEY_PROPERTY_PAGE_NUMBER = "PROPERTY_PAGE_NUMBER_V2";
export const PREFERENCE_KEY_PROPERTY_ADDRESS_ORDER =
  "PROPERTY_ADDRESS_ORDER_V2";
export const PREFERENCE_KEY_PROPERTY_CONTRACT_START_DATE_ORDER =
  "PROPERTY_CONTRACT_START_DATE_ORDER_RENT_V2";
